module.exports = __webpack_public_path__ + "assets/mobile-black.c534f1d5.svg";